"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function objectToKey(obj) {
    if (!obj) {
        return null;
    }
    const keys = Object.keys(obj);
    keys.sort();
    const sortedObj = keys.reduce((result, key) => {
        return {
            ...result,
            [key]: obj[key],
        };
    }, {});
    return JSON.stringify(sortedObj);
}
exports.default = objectToKey;
